import React from "react";
import { Star, Crosshair, Flame } from "lucide-react";

const ICONS = { rookie: Star, bandit: Crosshair, sheriff: Flame };
const MASCOTS = {
  rookie: "/brand/cup-beef.png",
  bandit: "/brand/cup-chicken.png",
  sheriff: "/brand/cup-sheriff.png",
};

const WantedPoster = ({ id, label, tagline, bounty, color, selected, onSelect, rotate }) => {
  const Icon = ICONS[id] || Star;
  const mascot = MASCOTS[id];
  return (
    <button
      type="button"
      onClick={() => onSelect(id)}
      data-testid={`difficulty-${id}-poster`}
      className={`poster text-left p-6 sm:p-8 transition-transform duration-150 ${
        selected ? "scale-[1.04]" : "hover:scale-[1.02]"
      }`}
      style={{
        transform: selected ? "" : `rotate(${rotate}deg)`,
        outline: selected ? "4px solid var(--red)" : "none",
        outlineOffset: "4px",
      }}
    >
      <div className="font-elite text-xs tracking-[0.3em] text-[color:var(--red)]">
        — WANTED FOR DUEL —
      </div>
      <div
        className="font-anton text-3xl sm:text-4xl mt-2 text-[color:var(--deepest-brown)]"
        style={{ letterSpacing: "0.04em" }}
      >
        {label.toUpperCase()}
      </div>
      <div className="font-elite text-sm mt-1 text-[color:var(--dark-brown)]">
        {tagline}
      </div>

      <div className="my-5 flex items-center justify-center relative" style={{ height: 200 }}>
        <div
          className="absolute rounded-full border-4 border-[color:var(--deepest-brown)]"
          style={{ width: 150, height: 150, background: color, top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
        />
        <img
          src={mascot}
          alt={label}
          className="relative z-10"
          style={{ height: 200, width: "auto", filter: "drop-shadow(4px 4px 0 rgba(58,29,4,0.45))" }}
          draggable={false}
        />
        <div className="absolute top-2 right-2 z-20">
          <Icon size={22} color="var(--red)" strokeWidth={2.5} />
        </div>
      </div>

      <div className="divider-rope my-3" />

      <div className="flex items-center justify-between font-anton text-[color:var(--deepest-brown)]">
        <span className="text-xs tracking-wider">REWARD</span>
        <span className="text-2xl">${bounty}</span>
      </div>
      <div className="font-elite text-[10px] mt-2 text-[color:var(--dark-brown)]">
        BOUNTY POSTED · APPLY AT THE FANTASTIC SALOON
      </div>
    </button>
  );
};

export default WantedPoster;
